import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { QuestionBase } from '../question-base';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'ntb-toggle',
    template: require('./toggle.component.html'),
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class ToggleComponent implements OnInit {
    @Input() question: any;
    @Input() questions: any = [];
    @Input() form: NgForm;
    // @Input() prefillData: any;
    fieldModel: any;
    pattern: string;
    @Output() fieldChange: EventEmitter<any> = new EventEmitter<any>();
    // @Output() onNumberChange: EventEmitter<any> = new EventEmitter<any>();
    constructor() {

    }
    ngOnInit() {

        if(!this.question.isClientOnly && typeof this.question.value === 'boolean') {
            if(this.question.value) {
                this.question.value = this.question.dataValues[0].code;
            }  else {
                this.question.value = this.question.dataValues[1].code;
            }
        }
        try {
            let isValueEmpty = typeof this.question.value === 'string' && this.question.value.trim();


                this.question.value = (this.question.value === '' || isValueEmpty === '')?
                 this.question.dataValues[0].code: this.question.value;

        } catch (e) {
        }
    }

    isActive(question,value) {
        if(question) {
         question.value = (question.value || typeof question.value === 'boolean')?
            question.value.toString():this.question.value;
            return question.value === value.code;
        }
        return false;


    }
    onFieldChange(event) {
        this.fieldChange.emit(this.question);
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/toggle/toggle.component.ts